import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface ApproveApiAccessResponse {
  message: string;
}

export const approveApiAccessRequest = async (
  token: string,
  userId: number,
  t: (key: string) => string
): Promise<ApproveApiAccessResponse> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/ApproveApiAccessRequest/${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to approve API access request");
    }

    const data: ApproveApiAccessResponse = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};